const ConfirmDialogReducer = (state = {}, action ) => {
    if(action.type === "UPDATE_CONFIRMDIALOG"){
        return action.ConfirmDialog 
    }
    return state
}
export default ConfirmDialogReducer;
